import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const SliderContainer = styled.div`
  width: 100%;
  padding: 20px 0;
`;

const SliderTrack = styled.div`
  width: 100%;
  height: 6px;
  background-color: #e0e0e0;
  border-radius: 3px;
  position: relative;
`;

const SliderFill = styled.div`
  height: 100%;
  background-color: #4caf50;
  border-radius: 3px;
  width: ${props => props.width}%;
`;

const SliderThumb = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #2196f3;
  position: absolute;
  top: 50%;
  left: ${props => props.left}%;
  transform: translate(-50%, -50%);
  cursor: pointer;
`;

const SliderLabels = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
`;

const SliderValue = styled.div`
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 10px;
`;

const BudgetSlider = ({ min, max, step, value, onChange }) => {
  const [sliderValue, setSliderValue] = useState(value);

  useEffect(() => {
    setSliderValue(value);
  }, [value]);

  const handleSliderChange = (e) => {
    const newValue = Number(e.target.value);
    setSliderValue(newValue);
    onChange(newValue);
  };

  const percentage = ((sliderValue - min) / (max - min)) * 100;

  return (
    <SliderContainer>
      <SliderValue>${sliderValue.toLocaleString()}</SliderValue>
      <SliderTrack>
        <SliderFill width={percentage} />
        <SliderThumb left={percentage} />
        <input
          type="range"
          min={min}
          max={max}
          step={step}
          value={sliderValue}
          onChange={handleSliderChange}
          style={{
            width: '100%',
            position: 'absolute',
            top: 0,
            left: 0,
            opacity: 0,
            cursor: 'pointer',
          }}
        />
      </SliderTrack>
      <SliderLabels>
        <span>${min.toLocaleString()}</span>
        <span>$380,000</span>
        <span>$650,000</span>
        <span>${max.toLocaleString()}</span>
      </SliderLabels>
    </SliderContainer>
  );
};

BudgetSlider.propTypes = {
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  step: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default BudgetSlider;